// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3zS_z","rootCenter":"LoadMoreObserver_rootCenter__2ZNas","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__TqwfE"};